import Repository from '../repositories/RepositoryFactory'
import { ErrorHandler } from '@/Helpers/ErrorHander'

function readErrorMessage (e) {
    return e.response?.data?.data?.message ?? e.message ?? 'Unexpected error'
}

export class MeterTypeService {
    constructor () {
        this.repository = Repository.get('meterType')
        this.meterTypesList = []
    }

    prepareMeterType(meterType){
        let meterTypeOnline = meterType.online === 1 ? 'Online' : 'Offline'
        let meterTypes = {
            id: meterType.id,
            name: meterType.max_current + 'A ' + meterType.phase + 'P ' + meterTypeOnline,
            max_current: meterType.max_current,
            phase: meterType.phase,
            online: meterType.online
        }
        return meterTypes
    }

    async getMeterTypes (){
        try {
            this.meterTypesList = []
            const { data, status } = await this.repository.index()
            if (status !== 200) {
                return new ErrorHandler(`Unexpected response status ${status}`, 'http', status)
            }
            // the endpoint answers with a plain list, or with a paginated payload when a limit is given
            const meterTypes = Array.isArray(data.data) ? data.data : (data.data?.data ?? [])
            this.meterTypesList = meterTypes.map(this.prepareMeterType)
            return this.meterTypesList
        }catch (e) {
            return new ErrorHandler(readErrorMessage(e), 'http')
        }
    }

    async createMeterType (meterType){
        try {
            const { status } = await this.repository.store(meterType)
            if (status !== 200 && status !== 201) {
                return new ErrorHandler(`Unexpected response status ${status}`, 'http', status)
            }
            return this.getMeterTypes()
        }catch (e) {
            return new ErrorHandler(readErrorMessage(e), 'http')
        }
    }

}
